import React from 'react';
import {Link} from "react-router-dom";
import {Button, Icon, Modal, Text} from "@gravity-ui/uikit"
import {TrashBin} from "@gravity-ui/icons";
import ProjectStatus, {
    ProjectDate, ProjectForSchool, ProjectKeywords, ProjectUpdateButton, ProjectVenue
} from "./utils"

import './ProjectCard.css'

function ProjectCard({children, project, onDelete}) {
    const [open, setOpen] = React.useState(false);

    const deleteModal = () => {
        return (
            <Modal open={open} onClose={() => setOpen(false)}>
                <div className="delete-project-modal">
                    <p>
                        Вы уверены, что хотите удалить проект "{project.name}"?
                    </p>
                    <div className="modal-buttons">
                        <Button onClick={() => onDelete(project.id)} view={"flat-danger"}>
                            Да, удалить
                        </Button>
                        <Button onClick={() => setOpen(false)} view={"normal"}>
                            Нет, отменить
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    }

    const deleteButton = () => {
        return (
            <Button view={"flat-danger"} size={"m"} onClick={() => setOpen(true)}>
                <Icon data={TrashBin} size={18}/>
            </Button>
        );
    }

    const canEditProject = () => {
        return (project.status === 'submitted' || project.status === 'returned');
    }

    return (
        <div className="workshop-list__item">
            <div className="pretitle w-100">
                <div className={"me-1"}>
                    <ProjectVenue venue={project.venue}/>
                </div>
                <div>
                    <ProjectForSchool is_for_schoolchildren={project.is_for_schoolchildren}/>
                    <ProjectStatus status={project.status}/>
                </div>
            </div>

            {canEditProject() ? <Link to={`${project.id}`} className="workshop-list__title">{project.name}</Link> :
                <Text className="workshop-list__title">{project.name}</Text>}

            <div className="workshop-list__tag">
                <ProjectKeywords keywords={project.keywords}/>
            </div>

            <div className="workshop-list__text">{project.description}</div>

            <div className="workshop-list__subtitle">
                <div className="workshop-list__subtitle__date">
                    <ProjectDate date={new Date(project.created_on)}/>
                </div>
                {canEditProject() && <div className="group-btn">
                    {deleteButton()}
                    <ProjectUpdateButton projectId={`${project.id}`}/>
                </div>}
            </div>
            {deleteModal()}
        </div>
    );
}

export default ProjectCard;